"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeedbackWidget = void 0;
var React = __importStar(require("react"));
var router_1 = require("next/router");
var client_1 = require("@skillrecordings/skill-api/dist/client");
var useFeedbackWidget = function (_a) {
    var location = _a.location;
    var router = (0, router_1.useRouter)();
    var _b = React.useState(false), isSubmitted = _b[0], setIsSubmitted = _b[1];
    var _c = React.useState(), error = _c[0], setError = _c[1];
    var submitFeedbackForm = React.useCallback(function (values_1, _a) { return __awaiter(void 0, [values_1, _a], void 0, function (values, _b) {
        var setSubmitting = _b.setSubmitting, resetForm = _b.resetForm;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setSubmitting(true);
                    return [4 /*yield*/, (0, client_1.sendFeedback)(values).then(function (error) {
                            if (error.error) {
                                console.error({ error: error });
                                setSubmitting(false);
                                setIsSubmitted(false);
                                setError(error.message);
                            }
                            else {
                                setSubmitting(false);
                                setIsSubmitted(true);
                                resetForm();
                            }
                        })];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var initialValues = {
        text: '',
        context: {
            category: 'general',
            emotion: ':wave:',
            url: "".concat(process.env.NEXT_PUBLIC_URL).concat(router.asPath),
            location: location,
        },
    };
    return {
        initialValues: initialValues,
        submitFeedbackForm: submitFeedbackForm,
        isSubmitted: isSubmitted,
        error: error,
    };
};
exports.useFeedbackWidget = useFeedbackWidget;
